import routerOptions0 from "/usr/src/app/content/n3-redirections-service-929a0c58-dca0-4673-8092-85269205ac2a/b2c-build/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}